/*!

=========================================================
* Black Dashboard React v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import { LOGIN_URL } from './config';

import 'core-js/stable';
import 'regenerator-runtime/runtime';
import React from 'react';
import ReactDOM from 'react-dom';
import { createBrowserHistory } from 'history';
import { Router, Route, Switch, Redirect } from 'react-router-dom';
import axios from 'axios';
import PrivateRoute from './utility/PrivateRoute';
// Global styles (consider splitting rarely-used library CSS later)
import './assets/scss/black-dashboard-react.scss';
import './assets/demo/demo.css';
import './assets/css/nucleo-icons.css';
// Removed heavy optional library CSS (lightbox, datepicker, reactflow) from initial bundle; loaded on-demand

// Route components code-split via React.lazy to reduce initial bundle size
const AppLayout = React.lazy(() => import('./layouts/App/App.jsx'));
const LoginLayout = React.lazy(() => import('./layouts/Login/Login.jsx'));
const NotFound = React.lazy(() => import('./components/NotFound'));
const Maintenance = React.lazy(() => import('./views/Maintenance.js'));
const AccessDenied = React.lazy(() => import('./views/AccessDenied'));

//REDIRECT OLD SITE TO NEW - TEMP TILL WE FIND DNS
if (window.location.hostname.indexOf('tria-labs.connectria.com') > -1) {
  window.location.hostname = 'next-gen.tria.connectria.com';
}

const hist = createBrowserHistory();
const ignoredRoutes = [
  'v3/auth/provider/local',
  '.js',
  '/login',
  '/tfa/verify',
  '/domain/organizations/get',
  '/cloud/all/cost/savings/',
  '/plugin/support/portal/',
  '/v3/auth/initiate',
    'resource_properties'
];
// Note: legacy HealthCheck & related unused code removed after introducing lazy loading

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    console.log(error);
    if (typeof error.response != 'undefined' && error.response.status === 401) {
      // const [stateApp, stateAppActions] = appState(); // removed unused to reduce overhead

      if (error.response != null && error.response.config != null) {
        for (var i = 0; i < ignoredRoutes.length; i++) {
          if (error.response.config.url.indexOf(ignoredRoutes[i]) > -1) return;
        }
      }
      //not on the login page, redirect
      console.log('unauthorized');
      //window.location.href = `https://login.mylightedge.com/?${buildRurl()}`;
      window.location.href = LOGIN_URL;
    }
    throw error;
  }
);

ReactDOM.render(
  <React.Suspense fallback={<div className="initial-loading" />}> {/* simple lightweight fallback */}
    <Router history={hist}>
      <Switch>
        <Redirect exact from="/" to="/app/dashboard" />
        <Route path="/login" exact render={(props) => <LoginLayout {...props} />} />
        <Route path="/access-denied" exact render={(props) => <AccessDenied {...props} />} />
        <Route path="/maintenance" exact render={(props) => <Maintenance {...props} />} />
        <PrivateRoute path="/app/*" component={AppLayout} />
        <Route path="*" component={NotFound} />
      </Switch>
    </Router>
  </React.Suspense>,
  document.getElementById('root'),
);
